__turbopack_context__.v({
  "button": "styles-module-scss-module__8efdJW__button",
});
